import Vue from 'vue';

const ORDINALS = ['صفرم', 'اول', 'دوم', 'سوم', 'چهارم', 'پنجم', 'ششم', 'هفتم', 'هشتم', 'نهم', 'دهم'];

function ordinal (x) {
    return ORDINALS[x] || x + '‌ام';
}

Vue.filter('persianOrdinal', ordinal);

export default ordinal;
